import { render } from "./ErrorPage401.vue?vue&type=template&id=5fcbf604&lang=html"
import script from "./ErrorPage401.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorPage401.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__